import React, { useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Gear, X } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';
import TradingRulesForm from './TradingRulesForm';

/**
 * TradingRulesSettingsModal - Modal wrapper for TradingRulesForm
 * 
 * Thin wrapper that adds modal header and footer around the reusable form component
 * Used in Health Dashboard context
 * 
 * @param {Object} settings - Settings object from parent
 * @param {Function} saveSettings - Function to save settings from parent
 * @param {Function} onSettingsSaved - Callback after successful save
 */
const TradingRulesSettingsModal = ({ show, onHide, accountId, account, settings, saveSettings, onSettingsSaved }) => {
  const { colors } = useTheme();
  const formRef = useRef();
  const effectiveAccountId = accountId || account?.AccountID;

  const handleFormSaved = () => {
    // Don't close the modal - let user close it manually
    // Just trigger refetch to update the data
    if (onSettingsSaved) {
      onSettingsSaved();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size="lg"
      backdrop="static"
    >
      <Modal.Header style={{ 
        backgroundColor: colors.bgCard, 
        borderBottom: `1px solid ${colors.border}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Gear size={20} style={{ color: colors.text }} />
          <Modal.Title style={{ 
            color: colors.text, 
            margin: 0,
            fontSize: '1.25rem',
            fontWeight: 600
          }}>
            Configure Trading Rules
          </Modal.Title>
        </div>
        <Button
          variant="outline-light"
          size="sm"
          onClick={onHide}
          style={{ 
            borderColor: colors.border,
            color: colors.text,
            padding: '4px 8px'
          }}
        >
          <X size={16} />
        </Button>
      </Modal.Header>
      
      <Modal.Body style={{ 
        backgroundColor: colors.bgPrimary, 
        padding: '24px',
        maxHeight: '70vh',
        overflowY: 'auto'
      }}>
        <TradingRulesForm
          ref={formRef}
          accountId={effectiveAccountId}
          settings={settings}
          saveSettings={saveSettings}
          standalone={false}
          onSave={handleFormSaved}
        />
      </Modal.Body>
      
    </Modal>
  );
};

export default TradingRulesSettingsModal;
